// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/constants.js#2 $
'use strict';
angular.module('tcApp')
.constant('tcConstants', {
	KEY_CODE: {
		BACKSPACE: 8,
		TAB: 9,
		ENTER: 13,
		ESCAPE: 27,
		SPACE: 32,
		PAGE_UP: 33,
		PAGE_DOWN: 34,
		END: 35,
		HOME: 36,
		LEFT_ARROW: 37,
		UP_ARROW: 38,
		RIGHT_ARROW: 39,
		DOWN_ARROW: 40,
		DELETE: 46,
		F6: 117,
		BACK_SLASH: 220,
		Z: 90,
		Y: 89,
		ALT: 18
	},
	KEY_HTMLCODE: {
		ARROWDOWN: '&darr;',
		ARROWUP: '&uarr;',
		ARROWLEFT: '&larr;',
		ARROWRIGHT: '&rarr;'
	},
	CROSS_DEVICE_EVENT: {
		//	This needs to be rewritten to use a service, as constants can't have dependencies
		//	but we require a reference to "$document" to check for click/touch events
		CLICK: (document.ontouchstart !== null) ? 'click' : 'touchend', // eslint-disable-line
	},
	MIME_TYPE: {
		PREVIEW_TYPES: ['image/jpeg', 'image/bmp', 'image/gif', 'image/png', 'application/dicom'],
		IMAGE_TYPES: ['image/jpeg', 'image/bmp', 'image/tiff', 'image/gif', 'image/png', 'application/dicom'],
		SOUND_TYPES: ['video/x-msvideo', 'video/mpeg', 'video/mpeg', 'audio/x-wav', 'audio/x-ms-wma', 'audio/x-ms-wmv'],
		DOC_TYPES: ['application/pdf', 'application/msword', 'application/msword', 'application/rtf', 'text/plain'],
		OTHER_TYPES: ['text/html', 'text/html', 'message/rfc822',
		'image/svg+xml', 'application/vnd.ms-excel', 'text/html', 'text/xml']
	},
	COLOURS: {
		// Should correspond to the colours in colours.scss
		BODY_FONT_COLOUR: '#4b4b4b'
	},
	ANIMATION: {
		SCROLL_DURATION: 500,
		SCROLL_FUNCTION: function(t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
	},
	URL_PROTOCOL: {
		HTTP: 'http',
		HTTPS: 'https',
		SKYPE: 'skype'
	},
	DIMENSIONS: {
		// Should match corresponding values in commonStyle / functions.scss
		REM_BASE: 16,
		REM_BASE_SCALE_FACTOR: 0.8,
		LINE_HEIGHT_REM: (26 / 16), // rem-calc(26);
		HEADER_HEIGHT: (2.4 * 16), // $headerHeight: 2.4rem;
		STICKY_ROW_OFFSET: 4,
	},
	PRINT_MODE: {
		SERVER: 1,
		LOCAL: 2,
		LOCAL_DIALOG: 3,
		LOCAL_TRAY: 4,
	},
	PRINT_URL: {
		AUTO: 'websys.print.auto.csp',
	},
	EDITOR: {
		MAX_RETRIES: 10,
		RETRY_DELAY: 300,
	},
	SORT_ORDER: {
		ASCENDING: 'A',
		DESCENDING: 'D'
	},
	COMPONENT_DISPLAY_MODE: {
		ACN: 'acn',
		OVERLAY: 'overlay',
	},
	COMPONENT_MESSAGE_TYPE: {
		ERROR: 'E',
		WARNING: 'W',
		INFO: 'I',
		JS_FUNCTION: 'J',
		TOAST: 'N'
	},
	COMPONENT_ITEM_STYLES: {
		// Should match standard type ResponsiveItemStyle and commonStyle.scss
		BOLD: 'commonItemStyleBold',
		ITALIC: 'commonItemStyleItalic',
		UNDERLINE: 'commonItemStyleUnderline',
		LINETHROUGH: 'commonItemStyleLineThrough',
		HEADING: 'commonItemStyleHeading',
		COUNTER: 'commonItemStyleCounter',
	},
	SESSION_TIMEOUT: {
		// Parameters controlling user inactivity timeout behavior, per Section 508 Compliance
		LOCK_COUNTDOWN: 20, // number of seconds given for user to extend session before session locks
		MAX_EXTEND_COUNT: 10, // maximum number of times the user can extend the session before the session will lock without warning
	},
	DATE_OPTIONS: {
		THAI_YEAR_SHIFT: 543,
	},
	BARCODE_END_KEY_CODES: [
		13, // Enter
		9 // Tab
	],
	NESTED_LIST_EXPAND_ACTION: {
		EXPAND: 'EXPAND',
		COLLAPSE: 'COLLAPSE',
	},
	LANG_DIRECTION: {
		RIGHT_TO_LEFT: 'rtl',
		LEFT_TO_RIGHT: 'ltr',
		AUTO: 'auto',
	},
	MONITOR_LIMITS: {
		WATCHERS: {
			CRITICAL: 7000,
			WARNING: 4000,
		},
	},
	LAYOUT_RESTRICTIONS: { // Standard Type -> Layout Restrictions
		ALLOW_FLOORPLAN: 'F',
		ALLOW_LAYOUT_PICKER: 'LP',
		ALLOW_QUESTIONNAIRE: 'Q',
		ALLOW_REPORT_PARAMETER: 'R',
	},
});
